import api from '../api';
import config from '../config';
import { requestAnalyticDismantle } from './analytics';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

function requestLogout() {
  return {
    type: LOGOUT_REQUEST
  };
}

function receiveLogout() {
  return {
    type: LOGOUT_SUCCESS
  };
}

export function logoutAccount(token) {
  return dispatch => {
    dispatch(requestLogout());

    return fetch(`${config.api.baseURL}/logout`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }).finally(() => {
      dispatch(api.actions.questionsList.reset());
      dispatch(requestAnalyticDismantle());
      dispatch(receiveLogout());
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/logout.js